<template>
  <div class="card-list">
    <el-row :gutter="20" v-if="dataList.length > 0">
      <el-col
        :xs="24"
        :sm="12"
        :md="8"
        :lg="6"
        :xl="4"
        v-for="i in dataList"
        :key="i.id"
      >
        <div
          class="box-card"
          @click="toPathDetail(i)"
          @mouseover="mouseover(i)"
          @mouseleave="mouseleave"
        >
          <div class="operate">
            <transition name="el-fade-in-linear">
              <i
                v-if="
                  userInfo.roleCodes.includes('admin') ||
                  userInfo.userId === i.createBy ||
                  userInfo.userId === i.leaderId
                "
                v-show="curIdHover === i"
                class="edit el-icon-edit"
                @click.stop="toPathEdit(i)"
              ></i>
            </transition>
            <transition name="el-fade-in-linear">
              <i
                v-if="
                  userInfo.roleCodes.includes('admin') ||
                  userInfo.userId === i.createBy
                "
                v-show="curIdHover === i"
                class="del el-icon-delete"
                @click.stop="delPop(i.id)"
              ></i>
            </transition>
          </div>
          <div class="sm-box" v-if="moduleType == 'researchGroup'">
            <h2>{{ i.groupName }}</h2>
            <h3>教研组长：{{ i.leaderName }}</h3>
            <h3>人数：{{ i.teacherList.length }}人</h3>
            <h3>学年：{{ i.schoolYear }}</h3>
            <h3>学期：{{ i.schoolTerm | revertTerm }}</h3>
          </div>
          <div class="sm-box" v-if="moduleType == 'researchProject'">
            <h2>{{ i.groupName }}</h2>
            <h3>主持人：{{ i.leaderName }}</h3>
            <h3>人数：{{ i.teacherNum }}人</h3>
            <h3>学年：{{ i.schoolYear }}</h3>
            <h3>学期：{{ i.schoolTerm | revertTerm }}</h3>
          </div>
          <div class="sm-box" v-if="moduleType == 'researchGroupAct'">
            <h2>活动名称：{{ i.actTitle }}</h2>
            <div class="mx clearfix">
              <span class="ing">{{ i.activeStatus | activeStatusFil }}</span>
            </div>
            <div class="tea-desc clearfix">
              <img
                :src="i.createLogo ? i.createLogo : defaultManPng"
                alt
                class="fl"
              />
              <span class="fl">{{ i.createName }}</span>
              <span style="font-size: 12px" class="fr">{{
                i.createSchool
              }}</span>
            </div>
          </div>
          <div class="sm-box" v-if="moduleType == 'researchProjectAct'">
            <h2>活动名称：{{ i.actTitle }}</h2>
            <div class="mx clearfix">
              <span class="ing">{{ i.activeStatus | activeStatusFil }}</span>
            </div>
            <div class="tea-desc clearfix">
              <img
                :src="i.createLogo ? i.createLogo : defaultManPng"
                alt
                class="fl"
              />
              <span class="fl">{{ i.createName }}</span>
              <span style="font-size: 12px" class="fr">{{
                i.createSchool
              }}</span>
            </div>
          </div>
          <div class="sm-box" v-if="moduleType == 'researchGroupTopic'">
            <h2>课题：{{ i.actTitle }}</h2>
            <div class="mx clearfix">
              <span class="ing">{{ i.activeStatus | activeStatusFil }}</span>
            </div>
            <div class="tea-desc clearfix">
              <img
                :src="i.createLogo ? i.createLogo : defaultManPng"
                alt
                class="fl"
              />
              <span class="fl">{{ i.createName }}</span>
              <span style="font-size: 12px" class="fr">{{
                i.createSchool
              }}</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-empty
      class="empty"
      :image-size="210"
      v-else
      description="暂无更多..."
    ></el-empty>
    <!-- 删除的对话框 -->
    <popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>
  </div>
</template>

<script>
import PopupDel from "@/components/PopupDel.vue";
import { mapState } from "vuex";
import { postData, postJson } from "../../http/fetch";
export default {
  props: {
    dataList: {
      type: Array,
      default: [],
    },
    moduleType: "", //researchGroup 教研组管理 researchGroupAct教研组活动 researchGroupTopic 教研组研究专题
  },
  filters: {
    revertStatus(val) {
      switch (val) {
        case 0:
          return "未开始";
        case 1:
          return "进行中";
        case 2:
          return "已结束";
      }
    },
    revertTerm(val) {
      switch (val) {
        case 1:
          return "上学期";
        case 2:
          return "下学期";
      }
    },
  },
  components: {
    PopupDel,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      delVisible: false,
      curIdHover: "",
      curId: "",
      defaultManPng: require("@/assets/image/other/man_teacher.png"),
    };
  },
  methods: {
    mouseover(id) {
      this.curIdHover = id;
    },
    mouseleave() {
      this.curIdHover = "";
    },
    toPathDetail(item) {
      if (this.moduleType == "researchGroup") {
        sessionStorage.setItem("groupCode", item.groupCode);
        this.$router.push({
          name: "editResearchGroup",
        });
      } else if (this.moduleType == "researchGroupAct") {
        sessionStorage.setItem("actCode", item.actCode);
        this.$router.push({
          name: "detailResearchGroupActMng",
        });
      } else if (this.moduleType == "researchGroupTopic") {
        sessionStorage.setItem("actCode", item.actCode);
        this.$router.push({
          name: "detailResearchGroupTopicMng",
        });
      } else if (this.moduleType == "researchProject") {
        sessionStorage.setItem("groupCode", item.groupCode);
        this.$router.push({
          name: "editResearchProject",
        });
      } else if (this.moduleType == "researchProjectAct") {
        sessionStorage.setItem("actCode", item.actCode);
        this.$router.push({
          name: "detailResearchProjectActMng",
        });
      }
    },
    toPathEdit(item) {
      if (this.moduleType == "researchGroup") {
        this.$emit("toPathEdit", item.groupCode);
      } else if (this.moduleType == "researchGroupAct") {
        this.$emit("toPathEdit", item.actCode);
      } else if (this.moduleType == "researchGroupTopic") {
        this.$emit("toPathEdit", item.actCode);
      } else if (this.moduleType == "researchProject") {
        this.$emit("toPathEdit", item.groupCode);
      } else if (this.moduleType == "researchProjectAct") {
        this.$emit("toPathEdit", item.actCode);
      }
    },
    delPop(id) {
      this.delVisible = true;
      this.curId = id;
    },
    async closePopupDel(status) {
      try {
        if (status) {
          if (this.moduleType == "researchGroup") {
            await postJson("/researchGroup/deleteResearchGroupInfo", {
              id: this.curId,
              operatorId: this.userInfo.userId,
            });
          } else if (this.moduleType == "researchGroupAct") {
            await postData("/research/deleteActiveInfo", {
              id: this.curId,
              operatorId: this.userInfo.userId,
            });
          } else if (this.moduleType == "researchGroupTopic") {
            await postData("/topic/deleteActiveInfo", {
              id: this.curId,
              operatorId: this.userInfo.userId,
            });
          } else if (this.moduleType == "researchProject") {
            await postJson("/projectGroup/deleteProjectGroupInfo", {
              id: this.curId,
              operatorId: this.userInfo.userId,
            });
          } else if (this.moduleType == "researchProjectAct") {
            await postData("/research/deleteActiveInfo", {
              id: this.curId,
              operatorId: this.userInfo.userId,
            });
          }
          this.$message({
            message: "删除成功",
            type: "success",
            duration: 2000,
            offset: 150,
          });
          this.delVisible = false;
          this.$emit("delSuccess");
        } else {
          this.delVisible = false;
        }
      } catch (err) {
        console.log("err", err);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.card-list {
  .el-col {
    margin-bottom: 15px;
    .box-card {
      width: 100%;
      cursor: pointer;
      background: #f6fafe;
      border-radius: 15px;
      border: 1px solid rgba(182, 179, 179, 0.5);
      position: relative;
      padding: 10px;
      box-sizing: border-box;
      height: 130px;
      overflow: hidden;
      .operate {
        i {
          position: absolute;
          top: 12px;
          font-size: 14.5px;
          color: rgb(214, 214, 214);
          padding: 4px;
          border-radius: 50%;
          background-color: @hui;
        }
        .edit {
          right: 15px;
        }
        .edit:hover {
          color: @color;
        }
        .del {
          right: 43px;
        }
        .del:hover {
          color: @color;
        }
      }

      h2 {
        font-size: 16px;
        color: #333;
        margin-left: 8px;
        line-height: 22px;
        font-weight: 500;
      }
      .mx {
        padding: 5px 8px;
        height: 30px;
        box-sizing: border-box;
        span {
          color: #fff;
          margin-right: 10px;
          padding: 3px 7px;
          border-radius: 7px;
        }
        .ing {
          background: @color;
        }
        .end {
          background: @hui;
        }
        .num {
          color: rgb(155, 154, 154);
        }
      }
      h3 {
        font-size: 12px;
        color: #333;
        margin-left: 8px;
        line-height: 22px;
      }
      .tea-desc {
        border-top: 1.5px solid #eee;
        padding: 6px 20px;
        padding-left: 0;
        height: 40px;
        box-sizing: border-box;
        img {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          border: 1px solid #eee;
        }
        span {
          margin-top: 4px;
          margin-left: 6px;
          font-size: 14px;
        }
      }
      .sm-box {
        height: 100%;
        display: flex;
        flex-direction: column;
        h2 {
          flex: 1;
        }
      }
    }
  }
  .empty {
    width: 210px;
    margin: 0 auto;
    text-align: center;
    font-size: 14px;
  }
}
</style>
